export enum CreateImageState {
  NoImageSaved = 1,
  ViewSavedImage = 2
}
